export const debounceTime = 600;
